<template>
    <div class="field is-grouped">
        <p class="control focus-visible-only">
            <button
                class="button is-link"
                :class="{'is-loading' : isRequestInProgress}"
                @click.prevent="isSending(true)"
            >
                {{ trans.leave_comment }}
            </button>
        </p>
        <p class="control">
            <button
                class="button is-outlined"
                @click.prevent="isSending(false)"
            >
                {{ trans.cancel_comment_button }}
            </button>
        </p>
    </div>
</template>

<script>
export default {
    name: "CommentSendCancelButtons",
    props: [
        'trans',
        'isRequestInProgress'
    ],
    methods: {
        isSending(value) {
            this.$emit('isAction', value);
        },
    },
}
</script>

<style lang="scss" scoped>
    .button {
        margin-top: 20px;
        height: 30px;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 18px;
        border-radius: 6px;
        font-family: RobotoWeb, "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    .button.is-link {
        width: 155px;
        margin-right: 10px;
        background: #2B67DF;
    }
    .button.is-outlined {
        background: #FFFFFF;
        border: 1px solid #2B67DF;
        box-sizing: border-box;
        border-radius: 6px;
        color: #2B67DF;
        position: absolute;
        width: 143px;
    }
</style>
